import { render, staticRenderFns } from "./leave-svg.vue?vue&type=template&id=48a75d56&scoped=true&"
var script = {}
import style0 from "./leave-svg.vue?vue&type=style&index=0&id=48a75d56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a75d56",
  null
  
)

export default component.exports